import React from 'react';
import { Button } from '../ui/Button';
export function Offer() {
  return <section className="py-10 px-4 bg-blue-900 text-white relative overflow-hidden" data-id="element-79">
      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-80">
        <div className="inline-block bg-red-600 text-white font-bold px-6 py-2 rounded-full text-sm mb-6 uppercase tracking-wider" data-id="element-81">
          ⏰ OFERTA LIMITADA
        </div>

        <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-82">
          Accedé hoy a TODO el MegaPack:
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl mx-auto mb-8 text-left" data-id="element-83">
          {['6 tomos completos', '3 bonos exclusivos', 'Acceso inmediato', 'Descarga digital', 'Acceso de por vida'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-white/10 p-3 rounded-lg" data-id="element-84">
              <span className="text-green-400 font-bold" data-id="element-85">✔</span>
              <span className="font-semibold" data-id="element-86">{item}</span>
            </div>)}
        </div>

        <div className="bg-white text-gray-900 rounded-2xl p-6 md:p-10 max-w-3xl mx-auto shadow-lg" data-id="element-87">
          <div className="flex flex-col justify-center items-center gap-1 mb-6" data-id="element-88">
            <div className="text-gray-500 line-through text-xl font-medium" data-id="element-89">
              Precio regular: $49.990
            </div>
            <div className="text-4xl md:text-6xl font-black text-red-600" data-id="element-90">
              🔥 HOY SOLO: $19.990
            </div>
          </div>

          <Button href="https://checkout.mediosdigitalespro.online/cart/42525422551111:1" size="xl" fullWidth className="text-xl md:text-2xl" data-id="element-91">
            👉 QUIERO ACCEDER CON DESCUENTO AHORA
          </Button>
        </div>
      </div>
    </section>;
}